import type { UseQueryOptions } from '@tanstack/react-query';

import type { ClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequiredResponse } from '../../@types/schema';
import {
  API_ENDPOINT,
  useClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequiredQuery,
} from '../../@types/schema';

export default function useCourseContractHistoriesInflearnMarketingConfirmRequiredQuery(
  options?: Omit<
    UseQueryOptions<
      ClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequiredResponse,
      unknown
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) {
  return useClientApiV1CourseContractHistoriesInflearnMarketingConfirmRequiredQuery({
    url: API_ENDPOINT.CLIENT_V1_COURSE_CONTRACT_HISTORIES_INFLEARN_MARKETING_CONFIRM_REQUIRED,
    queryKey: [
      API_ENDPOINT.CLIENT_V1_COURSE_CONTRACT_HISTORIES_INFLEARN_MARKETING_CONFIRM_REQUIRED,
    ],
    options: {
      ...options,
      suspense: false,
      useErrorBoundary: false,
    },
  });
}
